<template>
  <ErrorRetrievingData v-if="errorFetchingStatement" document-type="statement" class="min-h-[560px]" />
  <Stack v-if="displayContent" direction="col" gap="md" class="w-full pt-xs min-h-[560px]">
    <LazyStatement />
    <LazyMonthlyStatements v-if="hasStatements" />
    <LazyPayBalance />
  </Stack>
</template>

<script lang="ts" setup>
const { accountSummary, errorFetchingStatement } = useStatement();
const { checkForStatements } = useStatements();

const hasStatements = ref<boolean>(false);

const displayContent = computed(() => accountSummary.value && !errorFetchingStatement.value);

onMounted(async () => (hasStatements.value = await checkForStatements()));
</script>
